import colors from '../colors';

export interface ColorsTheme {
  colors: {
    black: string;
    abnNeutral50: string;
    abnNeutral55: string;
    abnNeutralsN65: string;
    abnNeutral90: string;
    abnNeutral200: string;
    abnNeutral300: string;
    abnNeutral400: string;
    abnNeutral610: string;
    abnGreen50: string;
    abnGreen100: string;
    abnGreen200: string;
    abnGreen300: string;
    abnGreen400: string;
    abnGreen500: string;
    abnGreen600: string;
    abnGreen670: string;
    abnMutedGreen400: string;
    abnYellow: string;
    abnNeutralWhite: string;
  };
}

export const bisColorsTheme: ColorsTheme = {
  colors: {
    black: colors.abnBlack,
    abnNeutral55: colors.abnNeutral55,
    abnNeutralsN65: colors.abnNeutralsN65,
    abnNeutral50: colors.abnNeutral50,
    abnNeutral90: colors.abnNeutral90,
    abnNeutral200: colors.abnNeutral200,
    abnNeutral300: colors.abnNeutral300,
    abnNeutral400: colors.abnNeutral400,
    abnNeutral610: colors.abnNeutral610,
    abnGreen50: colors.abnGreen50,
    abnGreen100: '#00A296',
    abnGreen200: colors.abnGreen500,
    abnGreen300: colors.abnGreen500,
    abnGreen400: colors.abnGreen500,
    abnGreen500: colors.abnGreen500,
    abnGreen600: colors.abnGreen600,
    abnGreen670: colors.abnGreen670,
    abnMutedGreen400: colors.abnMutedGreen400,
    abnYellow: colors.abnYellow,
    abnNeutralWhite: colors.white,
  },
};
